import React from 'react';
import Img from 'gatsby-image';
import styled from '@emotion/styled';
import { getFile } from '../../../utils/system';
import { sizing, color, font, breakpoints } from '../../../utils/style';

const PlayItemWrap = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  border-radius: 8px;
  background-color: ${color.darkPurple};
  width: 23.834%;
  padding: 2.25px 0;
  &:last-child {
    & .gatsby-image-wrapper {
      margin: 0px 15px;
    }
  }

  & .gatsby-image-wrapper {
    width: 150px;
  }
  & h4 {
    font-size: ${sizing.heading};
    color: ${color.blue};
    font-weight: ${font.headingWeight};
    text-transform: uppercase;
    margin: 0;
  }
  @media (max-width: ${breakpoints.md}) {
    h4 {
      font-size: ${sizing.large};
    }
    .gatsby-image-wrapper {
      width: 100px;
    }
  }
  @media (max-width: ${breakpoints.sm}) {
    width: 47.227%;
    justify-content: flex-start;
    padding: 14px 0 13px 0;
    flex-direction: column;
    h4 {
      margin-top: 7px;
      left: 0;
      text-align: center;
      max-width: 85px;
    }
    .gatsby-image-wrapper {
      height: 48px;
      width: 72px;
    }
  }
`;

const PlayItem = ({ image, title, altText = null }) => (
  <PlayItemWrap className="play-item">
    <Img fluid={getFile(image)} alt={altText || 'Play icon device'} />
    <h4>{title}</h4>
  </PlayItemWrap>
);

export default PlayItem;
